document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('form.product-form').forEach(form => {
    const btn = form.querySelector('button[type="submit"]');

    if (!btn) return;

    // Check if product has only 1 variant
    const variantSelect = form.querySelector('select');
    if (!variantSelect) {
      // Single-variant product → enable Add to Cart
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('disabled');
      btn.style.cursor = 'pointer';
      btn.style.opacity = '1';
    } else {
      // Multi-variant product → redirect to product page
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const productUrl = form.getAttribute('action').replace('/cart/add', '');
        window.location.href = productUrl;
      });
    }
  });
});
